import React, {useMemo} from 'react';
import styled from "styled-components";
import WallCell from "./WallCell";
import GiftCell from "./GiftCell";
import SantaCell from "./SantaCell";
import TreeCell from "./TreeCell";
import {StyledCell} from "./index";
import GrinchCell from "./GrinchCell";

const StyledMaze  = styled.div`
    background: white;
    display: flex;
    flex-wrap: wrap;
`;

const cellSize = 50;

const sampleMap = [
    ["w", "w", "P", "w", "w", "w", "w", "w", "w", "w"],
    ["w", "", "w", "w", "w", "w", "w", "w", "w", "w"],
    ["w", "w", "w", "w", "w", "w", "P", "w", "w", "w"],
    ["w", "w", "w", "w", "w", "w", "w", "", "w", "w"],
    ["w", "w", "w", "w", "w", "w", "w", "w", "w", "w"],
    ["w", "w", "w", "w", "w", "w", "w", "", "w", "w"],
    ["w", "w", "", "S", "w", "w", "T", "w", "w", "w"],
    ["w", "w", "w", "w", "w", "w", "w", "w", "w", "w"],
    ["w", "", "w", "w", "w", "w", "w", "w", "w", "w"],
    ["w", "w", "w", "w", "w", "w", "w", "w", "w", "w"],
]

const MazeContainer  = ({
    x = 10,
    y = 10,
    map = sampleMap,
    finished = false,
}) => {
    const maze = useMemo(() => {
        const cells = [];
        map.forEach((row, y) => {
            row.forEach((cell, x) => {
                const cellKey = cell.toUpperCase();
                switch (cellKey) {
                    case "W":
                        cells.push(<WallCell key={`${y}-${x}`} />);
                        break;
                    case "P":
                        cells.push(<GiftCell key={`${y}-${x}`} />);
                        break;
                    case "S":
                        if (finished) {
                            cells.push(<GrinchCell key={`${y}-${x}`} />);
                        } else {
                            cells.push(<SantaCell key={`${y}-${x}`} />);
                        }
                        break;
                    case "T":
                        cells.push(<TreeCell key={`${y}-${x}`} />);
                        break;
                    default:
                        cells.push(<StyledCell key={`${y}-${x}`} />);
                }
            })
        });

        return cells;

    }, [map, finished])


    return (
        <StyledMaze style={{ width: x * cellSize, height: y * cellSize }}>
            {maze}
        </StyledMaze>
    );
}

export default MazeContainer;
